var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPitchYourFilmProjectsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_24826",
    "data-name": "Group 24826",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.119,
    height: 46.779,
    viewBox: "0 0 39.119 46.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36411",
    "data-name": "Path 36411",
    d: "M38.859,22.67H7.307l1.054-.75c7.834-4.524,25.163-15.4,25.163-15.4a1.514,1.514,0,0,0,.553-2.059L32.571.752A1.513,1.513,0,0,0,30.509.2L2,17.525a1.517,1.517,0,0,0-.55,2.062l2.732,2.959L4.2,45.273a1.506,1.506,0,0,0,1.506,1.506H38.859a1.5,1.5,0,0,0,1.506-1.506v-21.1A1.508,1.508,0,0,0,38.859,22.67ZM27.928,24.449,23.275,28.97h-6.03l4.524-4.521ZM25.964,4.323,31.311.89l-.781,5.04L25.057,9.443ZM16.431,10.19,21.873,6.8,20.9,11.9,15.46,15.294ZM5.583,21.474l.913-5.12,5.4-3.451-.916,5.114Zm5.639,2.975h6.026L12.728,28.97H6.7Zm22.7,4.524H27.8l4.524-4.521H38.3Z",
    transform: "translate(-1.246 0)",
    fill: "#fc7336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchYourFilmProjectsIcon);
export default __webpack_public_path__ + "static/media/Pitch Your Film Projects_icon.359e6bf12643641fe1f6337551a6c026.svg";
export { ForwardRef as ReactComponent };